import { createContext, useContext, type PropsWithChildren } from "react";
import type { PointApi } from "../data/PointApi";

const Context = createContext<PointApi | null>(null);

export function PointProvider({ api, children }: PropsWithChildren<{ api: PointApi }>) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}

export function usePointApi() {
  const value = useContext(Context);
  if (!value) throw new Error("usePointApi must be used within PointProvider");
  return value;
}
